import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Property } from '../interfaces/property';
import { RentableUnit } from '../interfaces/tenants';

const ITEMS_KEY = 'property';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {

  constructor(private storage: Storage) {}
  addProperty(newProperty: Property): Promise<any> {
    return this.storage.get(ITEMS_KEY).then((allProperties: Property[]) => {
      if (allProperties) {
        allProperties.push(newProperty);
        return this.storage.set(ITEMS_KEY, allProperties);
      } else {
        return this.storage.set(ITEMS_KEY, [newProperty]);
      }
    });
  }
  getTargetDate(propertyId: string): Promise<any> {
    return this.storage.get(ITEMS_KEY).then((allProperties: Property[]) => {
      if(allProperties) {
        let prop: any = {};
        prop =  allProperties.find(p => p.id === propertyId);
        return prop.targetDates ? prop.targetDates : null;
      } else {
        return null;
      }
    })
  }

  getProperties(): Promise<any> {
    return this.storage.get(ITEMS_KEY);
  }

  deleteAllTenants(): Promise<any> {
    return this.storage.get(ITEMS_KEY).then((allProperties: Property[]) => {
      if(!allProperties || allProperties.length === 0) {
        return null;
      }
      let keepProperty: Property[] = [];
      return this.storage.set(ITEMS_KEY, keepProperty);
    });
    }
}

